import QuizController from '../modules/QuizController';

export default {
  quizController: null,

  init() {
    this.quizController = new QuizController('bravabod_bodytype');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/body.js